<template>
  <div :class="`animation animation-${loaded ? 'loaded' : 'wait'} animation-parachute animation-parachute-${theme}`">
    <parachute-svg/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import ParachuteSvg from '@/components/Animation/ParachuteSvg';

export default {
  components: {
    ParachuteSvg,
  },

  computed: mapGetters({
    loaded: 'loaded',
    theme: 'theme',
  }),

  mounted() {
    const SVG = window.SVG;

    const parachute = SVG.select('#parachute-wrap');
    parachute.opacity(0);

    if (this.theme === 'dark') {
      this.disableAnimation = true;
      this.timing = 1;
    }
    setTimeout(() => {
      setTimeout(() => {
        this.disableAnimation = false;
        this.timing = 1000;
        parachute.animate(300).opacity(1);
      }, 1000);

      this.initSVG();
      this.checkCurrentTheme();
    }, 200);
  },
  watch: {
    theme() {
      clearTimeout(this.disableTimeout);
      if (this.inViewport) {
        this.disableAnimation = false;
        this.checkCurrentTheme();
      } else {
        this.disableTimeout = setTimeout(() => {
          this.disableAnimation = true;
          this.checkCurrentTheme();
        }, 3000);
      }
    },
  },
  props: ['inViewport'],
  data() {
    return {
      timeoutsAnimation: {},
      disableAnimation: false,
      disableTimeout: null,
      firstPlay: true,
      suitcase: null,
      diagramm: null,
      columns: [],
      back: null,
      top: null,
      timing: 1000,
      ropes: [],
    };
  },
  methods: {
    initSVG() {
      const SVG = window.SVG;
      this.suitcase = SVG.select('#parachute-suitcase');
      this.diagramm = SVG.select('#parachute-diagramm');
      this.back = SVG.select('#parachute-back');
      this.top = SVG.select('#parachute-top');

      for (let p = 1; p <= 7; p += 1) {
        this.columns.push({
          root: SVG.select(`#parachute-columns-0${p}`),
        });
      }

      this.top.opacity(0).y(-200);
      this.back.opacity(0).y(-200);
      this.suitcase.opacity(0).y(-200);
      this.diagramm.y(-600).opacity(1).scale(1);

      this.ropes = [
        {
          root: SVG.select('#parachute-ropes-01'),
          transform: {
            rotate: -33,
            translate: {
              x: 15,
              y: -8,
            },
          },
        },
        {
          root: SVG.select('#parachute-ropes-02'),
          transform: {
            scale: 1.1,
            rotate: -39,
            translate: {
              x: 7,
              y: -6,
            },
          },
        },
        {
          root: SVG.select('#parachute-ropes-03'),
          transform: {
            scaleY: 1.5,
            rotate: -10,
            translate: {
              x: 37,
              y: -61,
            },
          },
        },
        {
          root: SVG.select('#parachute-ropes-04'),
          transform: {
            rotate: -22,
            translate: {
              x: -23,
              y: -18,
            },
          },
        },
        {
          root: SVG.select('#parachute-ropes-05'),
          transform: {
            scaleY: 1.9,
            rotate: 2,
            translate: {
              x: -8,
              y: -80,
            },
          },
        },
        {
          root: SVG.select('#parachute-ropes-06'),
          transform: {
            rotate: 14,
            translate: {
              x: 12,
              y: -22,
            },
          },
        },
        {
          root: SVG.select('#parachute-ropes-07'),
          transform: {
            rotate: 27,
            scaleY: 1.2,
            translate: {
              x: -16,
              y: -32,
            },
          },
        },
        {
          root: SVG.select('#parachute-ropes-08'),
          transform: {
            scaleY: 0.92,
            rotate: 37,
            translate: {
              x: -15,
              y: 0,
            },
          },
        },
      ];
    },

    checkCurrentTheme() {
      if (this.theme === 'dark') {
        this.darkStatus();
      } else {
        this.whiteStatus();
      }
    },

    whiteStatus() {
      this.clearTimeouts();
      this.disableAnimation = false;
      this.timing = 1000;
      for (let p = 0; p < this.columns.length; p += 1) {
        this.timeoutsAnimation[`column-${p}`] = setTimeout(() => {
          const el = this.columns[p];
          el.root.animate(700).y(0);
        }, 1500 + (p * 80));
      }
      this.top.animate(this.timing).opacity(0).y(-200);
      this.back.animate(this.timing).opacity(0).y(-200);
      this.suitcase.animate(this.timing).opacity(0).y(-200);
      const diaY = this.firstPlay ? 0 : 600;
      this.diagramm.animate(700).y(diaY);

      for (let p = 0; p < this.ropes.length; p += 1) {
        const el = this.ropes[p];

        el.root.animate(500).transform({
          scaleY: 1,
        });
        this.timeoutsAnimation.whiteMain = setTimeout(() => {
          el.root.animate(this.timing)
            .x(0)
            .y(0)
            .cy(-50)
            .rotate(0, 0, 0)
            .transform({
              scaleX: 1,
            });
        }, 600);
      }
      this.timeoutsAnimation.whiteDiagramm = setTimeout(() => {
        this.diagramm.animate(700).opacity(1).transform({
          scaleX: 1,
          scaleY: 1,
        });
      }, 200);
    },

    darkStatus() {
      this.clearTimeouts();
      this.firstPlay = false;
      for (let p = 0; p < this.columns.length; p += 1) {
        this.timeoutsAnimation[`column-${p}`] = setTimeout(() => {
          const el = this.columns[p];
          el.root.animate(this.disableAnimation ? 0 : 700).y(100);
        }, this.disableAnimation ? 0 : p * 80);
      }

      this.diagramm.animate(this.timing).transform({
        scaleX: 1.1,
        scaleY: 0.7,
      });

      this.diagramm.animate(this.disableAnimation ? 0 : 500).y(550);
      this.diagramm.animate(this.disableAnimation ? 0 : 700).opacity(0);

      this.timeoutsAnimation.darkMain = setTimeout(() => {
        this.back.animate(this.timing).opacity(1).y(0);
        this.top.animate(this.timing).opacity(1).y(0);

        for (let p = 0; p < this.ropes.length; p += 1) {
          const el = this.ropes[p];
          el.root.animate(this.disableAnimation ? 0 : 1700)
            .x(el.transform.translate.x)
            .y(el.transform.translate.y)
            .cy(0)
            .rotate(el.transform.rotate || 0)
            .transform({
              scaleX: 1,
              scaleY: el.transform.scaleY || 1,
            });
        }
      }, this.disableAnimation ? 0 : 300);

      this.timeoutsAnimation.darkSuitcase = setTimeout(() => {
        this.suitcase.animate(this.timing).opacity(1).y(0);
      }, this.disableAnimation ? 0 : 1000);
    },

    clearTimeouts() {
      for (let p = 0; p < this.columns.length; p += 1) {
        clearTimeout(this.timeoutsAnimation[`column-${p}`]);
      }
      clearTimeout(this.timeoutsAnimation.darkMain);
      clearTimeout(this.timeoutsAnimation.darkSuitcase);
      clearTimeout(this.timeoutsAnimation.whiteMain);
      clearTimeout(this.timeoutsAnimation.whiteDiagramm);
    },
  },
};
</script>


<style>
  .animation-parachute{
    transition: all .3s ease-in-out;
    position: absolute;
    max-width: 420px;
    height: auto;
    width: 35vw;
    opacity: 0;
    top: -1vw;
    right: -6vw;

    .page-service .col-service &{

      @media (max-width: $mediaLaptop) {
        width: 25vw;
        top: 3vw;
      }

      @media (max-width: $mediaMob) {
        right: -18vw;
        top: 5vw;
      }
    }

    &.animation-loaded{
      .page-theme.in-viewport &{
        opacity: 1;
      }
    }

    svg{
      width: 90%;

      .app-mozilla &,
      .app-chrome &,
      .app-safari &{
         height: 100%
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Animation/Parachute.vue